import backlinkApi from './backlinkNewApi';

export const backlinkSpamDomains = backlinkApi.injectEndpoints({
  endpoints: build => ({
    getSpamDomainsCount: build.query({
      query: body => ({
        url: '/api_backlink/v1/spam_domains/',
        method: 'POST',
        body: body
      })
    }),
    getSpamDomains: build.mutation({
      query: body => ({
        url: '/api_backlink/v1/spam_domains/',
        method: 'POST',
        body: body
      })
    })
  })
});

export const { useGetSpamDomainsCountQuery, useGetSpamDomainsMutation } =
  backlinkSpamDomains;
export default backlinkSpamDomains;
